import { Moment } from "moment";
import { API_URI, apiGet } from "./index";

const profile = {
  get: async (projectId: any, dateFrom: Moment, dateTo: Moment, streamIds: number[]) => {
    const data = await apiGet(`${API_URI}/api/profile/followers/get?&projectId=${projectId}&startDate=${dateFrom.format("DD MMM YYYY HH:mm")}&endDate=${dateTo.format("DD MMM YYYY HH:mm")}&streamIds=${streamIds.join(",")}`);
    return data;
  },
};

export default profile;
